module.exports = __webpack_public_path__ + "static/img/5.48b89ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/5.png
// module id = NbPR
// module chunks = 12